import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { LuRefreshCw } from "react-icons/lu";
import Card from "../../../src/components/Card.js";
import { useNavigate } from "react-router-dom";
import ModalUPT from "./modal/ModalUPT.js";
import RegistrasiService from "../../services/registrasi/RegistrasiService.js";
import topImage from "../../assets/images/dashboard/top-image.jpg";
import SweetAlert from "react-bootstrap-sweetalert";
import { format } from "date-fns";

const Register = () => {
    const [kodeUPT, setKodeUPT] = useState("");
    let RegService = useMemo(() => new RegistrasiService(), []);

    // trader
    const [trader, setTrader] = useState({
        JENIS_USAHA: "",
        NOMOR_KUSUKA: null,
        NAMA: null,
        NPWP: null,
        NO_IZIN: null,
        ALAMAT: null,
        PROPINSI: null,
        KOTA: null,
        KODEPOS: null,
        TELEPON: null,
        EMAIL: null,
        EMAIL_PNBP: null,
        KETERANGAN: null,
        TGL_DAFTAR: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        FILE_ID: "",
        STATUS: "0",
        // LAST_UPDATED: moment().format("YYYY/MM/DD"),
        LAST_UPDATED: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
    });

    // user
    const [user, setUser] = useState({
        ROLE: "4",
        KODE_TRADER: 0,
        USERNAME: "",
        PASSWORD: null,
        JNS_ID: "1",
        NO_ID: "",
        NAMA: "",
        ALAMAT: "",
        EMAIL: "",
        TELEPON: "",
        JABATAN: "",
        KD_UNIT: "1",
        STATUS: "0",
        STS_LOGIN: "0",
        DATE_LOGIN: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        IP_LOGIN: "",
        LAST_LOGIN: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        DATE_CREATED: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        USER_CREATED: 1,
        LAST_UPDATED: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        USER_UPDATED: 1,
    });

    const [propinsi, setPropinsi] = useState([]);
    const [kota, setKota] = useState([]);
    const [showUPT, setShowUPT] = useState(false);
    const handleCloseUPT = () => setShowUPT(false);
    const [namaUPT, setNamaUPT] = useState("");
    const [trade, setTrade] = useState([]);
    const [tradeFound, setTradeFound] = useState(false);
    const [existingUser, setExistingUser] = useState(false);

    const [pilihUPT, setPilihUPT] = useState(false);

    const [second, setSecond] = useState(false);
    const [first, setFirst] = useState(false);
    const [pilihService, setPilihService] = useState(false);
    const randomString = Math.random().toString(36).slice(8);
    const [captcha, setCaptcha] = useState(randomString);
    const [textCaptcha, setTextCaptcha] = useState("");
    const [validCaptcha, setValidCaptcha] = useState(false);
    const [folderName, setFolderName] = useState("");
    const [fileNPWP, setFileNPWP] = useState("");
    const [fileKTP, setFileKTP] = useState("");
    const [fileNIB, setFileNIB] = useState("");
    const [uploadNPWP, setUploadNPWP] = useState(false);
    const [uploadKTP, setUploadKTP] = useState(false);
    const [uploadNIB, setUploadNIB] = useState(false);

    const handlePilihUPT = () => {
        setPilihUPT(false);
    };

    const handleTradeService = () => {
        setPilihService(false);
    };

    const handleCaptcha = () => {
        setValidCaptcha(false);
    };

    const handleCloseRegister = () => {
        setSelesai(false);
        navigate("/");
    };

    const [selesai, setSelesai] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        // getMaxTrader();
        getPropinsi();
        refreshCaptcha();
        getFolderName();
    }, []);

    useEffect(() => {
        getKdUPT();
    }, [kodeUPT]);

    useEffect(() => {
        getKdTrader();
        propinsiChange2(trade.PROPINSI);
    }, [tradeFound]);

    const saveTrader = async (e) => {
        e.preventDefault();

        if (fileNPWP === "") {
            setUploadNPWP(true);
            return;
        }

        if (fileKTP === "") {
            setUploadKTP(true);
            return;
        }

        if (fileNIB === "") {
            setUploadNIB(true);
            return;
        }

        if (user.KD_UNIT === "1") {
            setPilihUPT(true);
            return;
        }

        const adaUser = await RegService.getUserName(user.USERNAME);
        if (adaUser.data != null) {
            setExistingUser(true);
            return;
        }

        if (textCaptcha !== captcha) {
            setValidCaptcha(true);
            return;
        }

        if (!first && !second) {
            setPilihService(true);
            return;
        }

        try {
            const userSave = {
                ROLE: user.ROLE,
                KODE_TRADER: user.KODE_TRADER,
                USERNAME: user.USERNAME,
                PASSWORD: user.PASSWORD,
                JNS_ID: user.JNS_ID,
                NO_ID: user.NO_ID,
                NAMA: user.NAMA,
                ALAMAT: user.ALAMAT,
                EMAIL: user.EMAIL,
                TELEPON: user.TELEPON,
                JABATAN: user.JABATAN,
                KD_UNIT: user.KD_UNIT,
                STATUS: user.STATUS,
                STS_LOGIN: user.STS_LOGIN,
                DATE_LOGIN: user.DATE_LOGIN,
                IP_LOGIN: user.IP_LOGIN,
                LAST_LOGIN: user.LAST_LOGIN,
                DATE_CREATED: user.DATE_CREATED,
                USER_CREATED: user.USER_CREATED,
                LAST_UPDATED: user.LAST_UPDATED,
                USER_UPDATED: user.USER_UPDATED,
            };
            if (!tradeFound) {
                // await RegService.registerTrader(trader);
                const formData = new FormData();
                formData.append("JENIS_USAHA", trader.JENIS_USAHA);
                formData.append("NOMOR_KUSUKA", trader.NOMOR_KUSUKA);
                formData.append("NAMA", trader.NAMA);
                formData.append("NPWP", trader.NPWP);
                formData.append("NO_IZIN", trader.NO_IZIN);
                formData.append("ALAMAT", trader.ALAMAT);
                formData.append("PROPINSI", trader.PROPINSI);
                formData.append("KOTA", trader.KOTA);
                formData.append("KODEPOS", trader.KODEPOS);
                formData.append("TELEPON", trader.TELEPON);
                formData.append("EMAIL", trader.EMAIL);
                formData.append("EMAIL_PNBP", trader.EMAIL_PNBP);
                formData.append("KETERANGAN", trader.KETERANGAN);
                formData.append("TGL_DAFTAR", trader.TGL_DAFTAR);
                formData.append("FILE_ID", trader.FILE_ID);
                formData.append("STATUS", trader.STATUS);
                formData.append("LAST_UPDATED", trader.LAST_UPDATED);
                // formData.append("FILE_NPWP", fileNPWP);
                // formData.append("FILE_KTP", fileKTP);
                // formData.append("FILE_NIB", fileNIB);
                await RegService.registerTrader(formData);
                const response = await RegService.getTraderNPWP(trader.NPWP);
                // setUser({ ...user, KODE_TRADER: response.data.KODE_TRADER });
                userSave.KODE_TRADER = response.data.KODE_TRADER;
            } else {
                setUser({ ...user, KODE_TRADER: trade.KODE_TRADER });
            }
            await RegService.registrasiUser(userSave);
            await RegService.createTraderUPT({
                KODE_TRADER: userSave.KODE_TRADER,
                KD_UNIT: kodeUPT,
                KODE_TRADER_LOKAL: null,
                STATUS: "0",
                TGL_AKTIF: null,
                USER_UPDATE: null,
                DATE_CREATED: format(new Date(), "yyyy-MM-dd' 'HH:mm:ss"),
            });
            if (first && second) {
                await RegService.registrasiService({
                    KODE_TRADER: userSave.KODE_TRADER,
                    KODE_LAYANAN: "3",
                    STS_VERIFIKASI: "0",
                });
            } else {
                if (first) {
                    await RegService.registrasiService({
                        KODE_TRADER: userSave.KODE_TRADER,
                        KODE_LAYANAN: "1",
                        STS_VERIFIKASI: "0",
                    });
                }
                if (second) {
                    await RegService.registrasiService({
                        KODE_TRADER: userSave.KODE_TRADER,
                        KODE_LAYANAN: "2",
                        STS_VERIFIKASI: "0",
                    });
                }
            }
            await RegService.createTraderDokumen({
                FILE_ID: trader.FILE_ID,
                DOK_KODE: "1",
                DOK_PATH: `${process.env.REACT_APP_API_URL_FILE}/view/${trader.FILE_ID}/${fileNPWP.name}`,
            });
            await RegService.putDokumen(trader.FILE_ID, fileNPWP);
            await RegService.createTraderDokumen({
                FILE_ID: trader.FILE_ID,
                DOK_KODE: "2",
                DOK_PATH: `${process.env.REACT_APP_API_URL_FILE}/view/${trader.FILE_ID}/${fileKTP.name}`,
            });
            await RegService.putDokumen(trader.FILE_ID, fileKTP);
            await RegService.createTraderDokumen({
                FILE_ID: trader.FILE_ID,
                DOK_KODE: "3",
                DOK_PATH: `${process.env.REACT_APP_API_URL_FILE}/view/${trader.FILE_ID}/${fileNIB.name}`,
            });
            await RegService.putDokumen(trader.FILE_ID, fileNIB);
            setSelesai(true);
            // navigate("/");
        } catch (error) {
            console.log(error);
        }
    };

    const checkTrader = async (e) => {
        try {
            const response = await RegService.getTrader(e.target.value);
            if (response.data != null) {
                // setTradeFound(true);
                // setTrade(response.data);
                // const resposeUser = await RegService.getUser(response.data.KODE_TRADER)
                // setUser(resposeUser.data);
            } else {
                setTrade([]);
                setTradeFound(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getFolderName = async () => {
        try {
            const response = await RegService.getFolderName();
            setFolderName(response.data);
            setTrader({ ...trader, FILE_ID: response.data });
        } catch (error) {
            console.log(error);
        }
    };
    const getKdUPT = () => {
        setUser({ ...user, KD_UNIT: kodeUPT });
    };

    const getKdTrader = () => {
        setUser({ ...user, KODE_TRADER: trade.KODE_TRADER });
    };

    const getTrade = async (e) => {
        try {
            const response = await RegService.getTraderNPWP(e.target.value);
            if (response.data != null) {
                setTradeFound(true);
                setTrade(response.data);
                const resposeUser = await RegService.getUser(response.data.KODE_TRADER);
                setUser(resposeUser.data);
                return;
            } else {
                setTrade([]);
                setTradeFound(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getPropinsi = async () => {
        try {
            setUser({ ...user, KODE_TRADER: 0 });
            const response = await RegService.getPropinsi();
            setPropinsi(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const propinsiChange = async (e) => {
        try {
            const response = await RegService.getKota(e.target.value);
            setKota(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const propinsiChange2 = async (kode) => {
        try {
            const response = await RegService.getKota(kode);
            setKota(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const routeChange = () => {
        navigate("/");
    };

    const handleClickUPT = () => {
        setShowUPT(true);
    };

    const handleExistingUser = () => {
        setExistingUser(false);
    };

    const handleTradeFound = () => {
        setTradeFound(false);
        routeChange();
    };

    function autoFormatNPWP(NPWPString) {
        try {
            var cleaned = ("" + NPWPString).replace(/\D/g, "");
            var match = cleaned.match(
                /(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,1})?(\d{0,3})?(\d{0,3})$/
            );
            return [
                match[1],
                match[2] ? "." : "",
                match[2],
                match[3] ? "." : "",
                match[3],
                match[4] ? "." : "",
                match[4],
                match[5] ? "-" : "",
                match[5],
                match[6] ? "." : "",
                match[6],
            ].join("");
        } catch (err) {
            return "";
        }
    }

    const handleChangeService = (value) => {
        if (value === "first") {
            setFirst(!first);
        }
        if (value === "second") {
            setSecond(!second);
        }
    };
    const handleNPWP = () => {
        setUploadNPWP(false);
    };

    const handleKTP = () => {
        setUploadKTP(false);
    };

    const handleNIB = () => {
        setUploadNIB(false);
    };

    const refreshCaptcha = () => {
        setCaptcha(Math.random().toString(36).slice(8));
    };

    const matchCaptcha = (event) => {
        if (textCaptcha === captcha) {
            setValidCaptcha(false);
        } else {
            setValidCaptcha(true);
        }
    };

    const loadImageNPWP = (e) => {
        const imageNPWP = e.target.files[0];
        setFileNPWP(imageNPWP);
    };

    const loadImageKTP = (e) => {
        const imageKTP = e.target.files[0];
        setFileKTP(imageKTP);
    };

    const loadImageNIB = (e) => {
        const imageNIB = e.target.files[0];
        setFileNIB(imageNIB);
    };

    return (
        <>
            <div className="header">
                <section className="register-content">
                    <Row className="m-0 align-items-center bg-white vh-100">
                        <Col
                            md="12"
                            style={{
                                background: `url(${topImage})`,
                                backgroundSize: "cover",
                                backgroundRepeat: "norepeat",
                                height: "100vh",
                                position: "relative",
                            }}
                        >
                            <Row className="justify-content-center">
                                <Col md="10">
                                    <Card className="card-transparent shadow-sm d-flex justify-content-center mb-0 auth-card mt-5 mb-5 border">
                                        <Card.Body>
                                            <h2 className="mb-3 mt-4 fw-bold text-primary">
                                                Form Registrasi
                                            </h2>
                                            <ul>
                                                <li>
                                                    Harap isi data dengan benar sesuai dengan dokumen atau
                                                    berkas resmi yang Anda miliki.
                                                </li>
                                                <li>Data dengan tanda bintang (*) harus diisi.</li>
                                                <li>
                                                    Jenis file yang bisa diupload .pdf, .png, .jpg atau
                                                    .jpeg dan ukuran Maks. file 1 Mb
                                                </li>
                                            </ul>
                                            <h4 className="mb-5 mt-5">Data Umum Pengguna Jasa</h4>
                                            <Form onSubmit={saveTrader}>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="npwp"
                                                    >
                                                        {`NPWP Perusahaan*`}
                                                    </Form.Label>
                                                    <Col sm="4">
                                                        <Row>
                                                            <Col>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="npwp"
                                                                    id="npwp"
                                                                    pattern=".{21}"
                                                                    maxLength="{21}"
                                                                    placeholder="NPWP Perusahaan 16 Digit"
                                                                    required
                                                                    value={trader.NPWP}
                                                                    onChange={(e) => {
                                                                        getTrade(e);
                                                                        setTrader({
                                                                            ...trader,
                                                                            NPWP: e.target.value,
                                                                        });
                                                                    }}
                                                                    onInput={(e) => {
                                                                        e.target.value = autoFormatNPWP(
                                                                            e.target.value
                                                                        );
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col sm="5">
                                                        <Row>
                                                            <Col>
                                                                <Form.Control
                                                                    type="file"
                                                                    id="NPWPFile"
                                                                    onChange={loadImageNPWP}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0"
                                                        htmlFor="nmPerusahaan"
                                                    >
                                                        Nama Perusahaan*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            id="nmPerusahaan"
                                                            defaultValue=""
                                                            type="Text"
                                                            placeholder="Nama Perusahaan"
                                                            value={tradeFound ? trade.NAMA : trader.NAMA}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({ ...trader, NAMA: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0"
                                                        htmlFor="nmPemilik"
                                                    >
                                                        Nama Pengguna*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            id="nmUser"
                                                            type="Text"
                                                            required
                                                            placeholder="Nama Pengguna (Susuai Nama KTP)"
                                                            value={tradeFound ? user.NAMA : user.NAMA}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, NAMA: e.target.value })
                                                            }
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0"
                                                        htmlFor="jabatan"
                                                    >
                                                        Jabatan*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            id="jabatan"
                                                            type="Text"
                                                            placeholder="Jabatan"
                                                            value={tradeFound ? user.JABATAN : user.JABATAN}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, JABATAN: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-top mb-0"
                                                        htmlFor="noidentitas"
                                                    >
                                                        No. Identitas KTP/KITAS*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Row>
                                                            <Col sm="3">
                                                                <select
                                                                    className="form-select mb-3 shadow-none"
                                                                    value={user.JNS_ID}
                                                                    onChange={(e) =>
                                                                        setUser({ ...user, JNS_ID: e.target.value })
                                                                    }
                                                                >
                                                                    <option defaultValue>Pilih Identitas</option>
                                                                    <option value="1">KTP</option>
                                                                    <option value="2">SIM</option>
                                                                    <option value="3">Kartu Keluarga</option>
                                                                </select>
                                                            </Col>
                                                            <Col sm="9">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Nomor Identitas"
                                                                    value={tradeFound ? user.NO_ID : user.NO_ID}
                                                                    disabled={tradeFound ? true : false}
                                                                    onChange={(e) =>
                                                                        setUser({ ...user, NO_ID: e.target.value })
                                                                    }
                                                                    required
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <Form.Control
                                                                    type="file"
                                                                    id="KTPFile"
                                                                    onChange={loadImageKTP}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="email"
                                                    >
                                                        Nomor Induk Berusaha (NIB)
                                                    </Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 ps-5"
                                                        htmlFor="nomor"
                                                    >
                                                        Nomor*
                                                    </Form.Label>
                                                    <Col sm="4">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="Nomor izin usaha"
                                                            value={
                                                                tradeFound ? trade.NO_IZIN : trader.NO_IZIN
                                                            }
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({
                                                                    ...trader,
                                                                    NO_IZIN: e.target.value,
                                                                })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                    <Col sm="5">
                                                        <Form.Control
                                                            type="file"
                                                            id="NIBFile"
                                                            onChange={loadImageNIB}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="addr_pengguna"
                                                    >
                                                        Alamat Pengguna Jasa
                                                    </Form.Label>
                                                </Form.Group>

                                                {/* Alamat Rumah */}
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="addr_rumah"
                                                    >
                                                        Alamat Rumah
                                                    </Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-top mb-0 ps-5"
                                                        htmlFor="penerbit"
                                                    >
                                                        Jalan / No / Rt / Rw
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            as="textarea"
                                                            id="exampleFormControlTextarea1"
                                                            rows="5"
                                                            placeholder="Alamat Rumah"
                                                            value={tradeFound ? user.ALAMAT : user.ALAMAT}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, ALAMAT: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="email"
                                                    >
                                                        Pos Elektronik/Email*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Email"
                                                            placeholder="Email Pengguna"
                                                            value={tradeFound ? user.EMAIL : user.EMAIL}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, EMAIL: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 ps-5"
                                                        htmlFor="hand_rumah"
                                                    >
                                                        Nomor Handphone*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="Nomor Handphone"
                                                            value={tradeFound ? user.TELEPON : user.TELEPON}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, TELEPON: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                {/* Alamat Kantor */}
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="addr_rumah"
                                                    >
                                                        Alamat Kantor
                                                    </Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-top mb-0  ps-5"
                                                        htmlFor="addr_kantor"
                                                    >
                                                        Jalan / No / Rt / Rw
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            as="textarea"
                                                            id="exampleFormControlTextarea1"
                                                            rows="5"
                                                            placeholder="Alamat Kantor"
                                                            value={tradeFound ? trade.ALAMAT : trader.ALAMAT}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({ ...trader, ALAMAT: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0  ps-5"
                                                        htmlFor="propinsi_kantor"
                                                    >
                                                        Propinsi*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <select
                                                            className="form-select mb-3 shadow-none"
                                                            value={
                                                                tradeFound ? trade.PROPINSI : trader.PROPINSI
                                                            }
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) => {
                                                                setTrader({
                                                                    ...trader,
                                                                    PROPINSI: e.target.value,
                                                                });
                                                                propinsiChange(e);
                                                            }}
                                                            required
                                                        >
                                                            <option defaultValue>Pilih Propinsi</option>
                                                            {propinsi.map((item) => (
                                                                <option value={item.KODE_PROPINSI}>
                                                                    {item.URAIAN_PROPINSI}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label  align-self-center mb-0  ps-5"
                                                        htmlFor="kab_kota_kantor"
                                                    >
                                                        Kabupaten / Kota*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <select
                                                            className="form-select mb-3 shadow-none"
                                                            value={tradeFound ? trade.KOTA : trader.KOTA}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({ ...trader, KOTA: e.target.value })
                                                            }
                                                            required
                                                        >
                                                            <option defaultValue>Pilih Kabupaten/Kota</option>
                                                            {kota.map((item) => (
                                                                <option value={item.KODE_KOTA}>
                                                                    {item.URAIAN_KOTA}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 ps-5"
                                                        htmlFor="kd_pos_kantor"
                                                    >
                                                        Kode Pos
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="Kode Pos"
                                                            value={
                                                                tradeFound ? trade.KODEPOS : trader.KODEPOS
                                                            }
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({
                                                                    ...trader,
                                                                    KODEPOS: e.target.value,
                                                                })
                                                            }
                                                        // required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 ps-5"
                                                        htmlFor="telp_kantor"
                                                    >
                                                        Telepon / Faksimili
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="Telepon Kantor"
                                                            value={
                                                                tradeFound ? trade.TELEPON : trader.TELEPON
                                                            }
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({
                                                                    ...trader,
                                                                    TELEPON: e.target.value,
                                                                })
                                                            }
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark  ps-5"
                                                        htmlFor="email_kantor"
                                                    >
                                                        Pos Elektronik / Email*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Email"
                                                            placeholder="Email Kantor"
                                                            value={tradeFound ? trade.EMAIL : trader.EMAIL}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({ ...trader, EMAIL: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-top mb-0  ps-5"
                                                        htmlFor="ket_kantor"
                                                    >
                                                        Keterangan
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            as="textarea"
                                                            id="exampleFormControlTextarea1"
                                                            rows="5"
                                                            placeholder="Keterangan"
                                                            value={
                                                                tradeFound
                                                                    ? trade.KETERANGAN
                                                                    : trader.KETERANGAN
                                                            }
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setTrader({
                                                                    ...trader,
                                                                    KETERANGAN: e.target.value,
                                                                })
                                                            }
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="addr_pengguna"
                                                    >
                                                        Unit Pelaksana Teknis
                                                    </Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="email_kantor"
                                                    >
                                                        UPT*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Row>
                                                            <Col sm="11">
                                                                <Form.Control
                                                                    type="Text"
                                                                    placeholder="UPT"
                                                                    value={namaUPT}
                                                                    onChange={getKdUPT}
                                                                    disabled={true}
                                                                // required
                                                                />
                                                            </Col>
                                                            <Col sm="1" className="align-self-center">
                                                                <Button
                                                                    size="sm"
                                                                    variant="primary"
                                                                    onClick={() => handleClickUPT()}
                                                                >
                                                                    <FaSearch />
                                                                    {/* Pilih UPT */}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark"
                                                        htmlFor="user_login"
                                                    >
                                                        Data Userlogin
                                                    </Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="user_login"
                                                    >
                                                        User Name*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="User Name"
                                                            value={tradeFound ? "" : user.USERNAME}
                                                            disabled={tradeFound ? true : false}
                                                            onChange={(e) =>
                                                                setUser({ ...user, USERNAME: e.target.value })
                                                            }
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="user_login"
                                                    >
                                                        Security Code*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="Text"
                                                            placeholder="Security Code"
                                                            // value={tradeFound ? "" : user.USERNAME}
                                                            // disabled={tradeFound ? true : false}
                                                            onChange={(e) => setTextCaptcha(e.target.value)}
                                                            required
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="user_login"
                                                    ></Form.Label>
                                                    <Col sm="2" className="d-flex">
                                                        <Button
                                                            size="sm"
                                                            variant="primary"
                                                            onClick={() => refreshCaptcha()}
                                                            className="me-2"
                                                        >
                                                            <LuRefreshCw />
                                                        </Button>
                                                        <h4 className="text-center text-dark bg-warning px-4 py-2 user-select-none">
                                                            {captcha}
                                                        </h4>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="form-group">
                                                    <Form.Label
                                                        column
                                                        sm="3"
                                                        className="control-label align-self-center mb-0 text-dark ps-5"
                                                        htmlFor="jenis_layanan"
                                                    >
                                                        Jenis Layanan*
                                                    </Form.Label>
                                                    <Col sm="9">
                                                        <Row>
                                                            <Col>
                                                                <Form.Check className="d-block">
                                                                    <Form.Check.Input
                                                                        className="me-2"
                                                                        type="checkbox"
                                                                        defaultValue=""
                                                                        id="checkSMKHP"
                                                                        value={first}
                                                                        onChange={() =>
                                                                            handleChangeService("first")
                                                                        }
                                                                    />
                                                                    <Form.Check.Label htmlFor="checkSMKHP">
                                                                        Sertifikasi SMKHP
                                                                    </Form.Check.Label>
                                                                </Form.Check>
                                                            </Col>
                                                            <Col>
                                                                <Form.Check className="d-block">
                                                                    <Form.Check.Input
                                                                        className="me-2"
                                                                        type="checkbox"
                                                                        defaultValue=""
                                                                        id="checkPBUMKU"
                                                                        value={second}
                                                                        onChange={() =>
                                                                            handleChangeService("second")
                                                                        }
                                                                    />
                                                                    <Form.Check.Label htmlFor="checkPBUMKU">
                                                                        PBUMKU
                                                                    </Form.Check.Label>
                                                                </Form.Check>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Check className="mb-5 mt-5">
                                                        <Form.Check.Input
                                                            className="me-2"
                                                            type="checkbox"
                                                            defaultValue
                                                            id="invalidCheck2"
                                                            required
                                                        />
                                                        <Form.Check.Label htmlFor="invalidCheck2">
                                                            Setuju dengan syarat dan ketentuan
                                                        </Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                                <div className="text-center ali mt-5">
                                                    <Button
                                                        type="submit"
                                                        variant="btn btn-primary"
                                                        disabled={tradeFound ? true : false}
                                                    >
                                                        Submit
                                                    </Button>{" "}
                                                    <Button
                                                        type="button"
                                                        variant="btn btn-danger"
                                                        onClick={routeChange}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <ModalUPT
                        setKodeUPT={setKodeUPT}
                        setNamaUPT={setNamaUPT}
                        showUPT={showUPT}
                        handleCloseUPT={handleCloseUPT}
                    />
                </section>
            </div>
            {uploadNPWP && (
                <SweetAlert
                    title="File NPWP Belum di Upload"
                    danger
                    onConfirm={handleNPWP}
                    btnSize="sm"
                />
            )}
            {uploadKTP && (
                <SweetAlert
                    title="File KTP Belum di Upload"
                    danger
                    onConfirm={handleKTP}
                    btnSize="sm"
                />
            )}
            {uploadNIB && (
                <SweetAlert
                    title="File NIB Belum di Upload"
                    danger
                    onConfirm={handleNIB}
                    btnSize="sm"
                />
            )}
            {pilihService && (
                <SweetAlert
                    title="Jenis Layanan Belum Dipilih"
                    danger
                    onConfirm={handleTradeService}
                    btnSize="sm"
                />
            )}
            {tradeFound && (
                <SweetAlert
                    title="Pengguna Jasa Sudah Terdaftar"
                    info
                    onConfirm={handleTradeFound}
                    btnSize="sm"
                />
            )}
            {selesai && (
                <SweetAlert
                    title="Registrasi Berhasil"
                    success
                    onConfirm={handleCloseRegister}
                    btnSize="sm"
                >
                    Terima kasih telah melakukan registrasi, konfirmasi user akan
                    dikirimkan melalui email terdaftar
                </SweetAlert>
            )}
            {existingUser && (
                <SweetAlert
                    title="Username tidak tersedia"
                    danger
                    onConfirm={handleExistingUser}
                    btnSize="sm"
                />
            )}
            {pilihUPT && (
                <SweetAlert
                    title="UPT belum dipilih"
                    danger
                    onConfirm={handlePilihUPT}
                    btnSize="sm"
                />
            )}
            {validCaptcha && (
                <SweetAlert
                    title="Kode Security Tidak Sesuai"
                    danger
                    onConfirm={handleCaptcha}
                    btnSize="sm"
                />
            )}
        </>
    );
};

export default Register;
